import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LayoutMain" }

import { defineAsyncComponent } from 'vue';
import { useLogin } from 'Store';
import CONFIG from 'Config';
import ControlRender from 'Components/ControlRender/ControlRender.vue';
import TheHeader from 'Components/TheHeader/TheHeader.vue';
import TheFooter from 'Components/TheFooter/TheFooter.vue';
import TheModal from 'Components/TheModal/TheModal.vue';
import /* webpackChunkName: ‘AcreCookieConsent’ */ 'AcreComponents/AcreCookieConsent/AcreCookieConsent.umd';


export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutMain',
  setup(__props) {

const BannerInvestmentDocuments = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerInvestmentDocuments" */ 'Components/BannerInvestmentDocuments/BannerInvestmentDocuments.vue'
));
const BannerEmailVerification = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerEmailVerification" */ 'Components/BannerEmailVerification/BannerEmailVerification.vue'
));
const BannerMaintenance = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerMaintenance" */ 'Components/BannerMaintenance/BannerMaintenance.vue'
));

const BannerYSAnnouncment = defineAsyncComponent(() => import(
  /* webpackChunkName: "BannerYSAnnouncment" */ 'Components/BannerYSAnnouncment/BannerYSAnnouncment.vue'
));

const { isLoggedIn } = useLogin();

return (_ctx: any,_cache: any) => {
  const _component_acre_cookie_consent = _resolveComponent("acre-cookie-consent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TheHeader, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16),
    _createVNode(ControlRender, {
      "excluded-for-prerender": "",
      "when-visible": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_acre_cookie_consent, {
          domain: _unref(CONFIG).urls.frontend,
          "link-href": "/company/privacy#we-use-following-tools"
        }, null, 8, ["domain"])
      ]),
      _: 1
    }),
    _createVNode(ControlRender, {
      "when-logged-in": "",
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        (_unref(isLoggedIn))
          ? (_openBlock(), _createBlock(_unref(BannerInvestmentDocuments), { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ControlRender, {
      "when-logged-in": "",
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        (_unref(isLoggedIn))
          ? (_openBlock(), _createBlock(_unref(BannerEmailVerification), { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ControlRender, {
      "when-visible": "",
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BannerMaintenance))
      ]),
      _: 1
    }),
    _createVNode(ControlRender, {
      "when-visible": "",
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BannerYSAnnouncment))
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(TheFooter),
    _createVNode(TheModal)
  ]))
}
}

})